import { createReducer } from '@reduxjs/toolkit'

 const row = createReducer({}, {
    SELECT_ROW: (state, action) => {
        state.selected = action.payload;
    },
    SELECT_ROW_UP: (state, action) => {
        const rowId = action.payload.rowId;
        if (rowId.indexOf('if') !== -1) {
            let rowIndex = parseInt(rowId.substring(rowId.lastIndexOf('if') + 2)) - 1;
            const rowIndexPrefix = rowId.substring(0, rowId.lastIndexOf('if') + 2);
            state.selected = `${rowIndexPrefix}${rowIndex}`;

        } else if (rowId.indexOf('else') !== -1) {
            let rowIndex = parseInt(rowId.substring(rowId.lastIndexOf('else') + 4)) - 1;
            const rowIndexPrefix = rowId.substring(0, rowId.lastIndexOf('else') + 4);
            state.selected = `${rowIndexPrefix}${rowIndex}`;
        } else {
            let rowIndex = parseInt(rowId.substring(rowId.lastIndexOf('_') + 1)) - 1;
            const rowIndexPrefix = rowId.substring(0, rowId.lastIndexOf('_') + 1);
            state.selected = `${rowIndexPrefix}${rowIndex}`;
        }
    },
    SELECT_ROW_DOWN: (state, action) => {
        const rowId = action.payload.rowId;
        if (rowId.indexOf('if') !== -1) {
            let rowIndex = parseInt(rowId.substring(rowId.lastIndexOf('if') + 2)) + 1;
            const rowIndexPrefix = rowId.substring(0, rowId.lastIndexOf('if') + 2);
            state.selected = `${rowIndexPrefix}${rowIndex}`;
        } else if (rowId.indexOf('else') !== -1) {
            let rowIndex = parseInt(rowId.substring(rowId.lastIndexOf('else') + 4)) + 1;
            const rowIndexPrefix = rowId.substring(0, rowId.lastIndexOf('else') + 4);
            state.selected = `${rowIndexPrefix}${rowIndex}`;
        } else {
            let rowIndex = parseInt(rowId.substring(rowId.lastIndexOf('_') + 1)) + 1;
            const rowIndexPrefix = rowId.substring(0, rowId.lastIndexOf('_') + 1);
            state.selected = `${rowIndexPrefix}${rowIndex}`;
        }
    },
    CLEAR_ROW_SELECTION: (state, action) => {
        state.selected = '';
    }
 })
 
 export default row;